/**
 * 随机生成一个 id
 * copy from: https://github.com/facebook/draft-js/blob/main/src/model/keys/generateRandomKey.js
 */
var keys = {};
var MULTIPLIER = Math.pow(2, 24);
export var randomKey = function () {
    var key;
    while (key === undefined || keys.hasOwnProperty(key) || !isNaN(+key)) {
        key = Math.floor(Math.random() * MULTIPLIER).toString(32);
    }
    keys[key] = true;
    return key;
};
//# sourceMappingURL=random-key.js.map